import { useAuthService } from '@/services/auth';
import LocalSignInPage from './LocalSignInPage';
import CognitoSignInPage from './CognitoSignInPage';

const SignInPage = () => {
  const { authType } = useAuthService();

  switch (authType) {
    case 'cognito': {
      return <CognitoSignInPage />;
    }
    case 'local': {
      return <LocalSignInPage />;
    }
  }
};

export default SignInPage;
